export default __webpack_public_path__ + "static/media/avatar.efadb13d.webp";